export function PayScheduleBanner() {
  return (
    <div className="bg-igc-surface border border-igc-gold/20 p-5 flex items-center justify-between gap-4 flex-wrap" data-testid="pay-schedule-banner">
      <div>
        <p className="text-igc-goldText text-xs uppercase tracking-widest mb-1">Pay Schedule</p>
        <p className="text-igc-cream text-sm">Payments run every <span className="text-igc-goldText">Friday</span>.</p>
      </div>
      <div className="text-right">
        <p className="text-igc-muted text-xs uppercase tracking-widest mb-1">Cutoff</p>
        <p className="text-igc-cream text-sm">Deals confirmed after <span className="text-igc-goldText">Wednesday, 12:00 Noon Eastern</span> roll to the following Friday.</p>
      </div>
    </div>
  );
}
